import gql from "graphql-tag";

export const NotInterestedTitle = {
    name: "Not Interested",
    translationKey: "notInterestedTitle",
};

export const NotInterestedSubtitle = {
    name: "Please let us know why you're not interested so we can improve your experience!",
    translationKey: "notInterestedSubtitle",
};

export const NotInterestedDropdownLabel = {
    name: "Reason",
    translationKey: "notInterestedDropdownLabel",
};

export const NotInterestedSubmit = {
    name: "Submit response",
    translationKey: "notInterestedSubmit",
};

export const NotInterestedReasonValidation = {
    name: "Reason is a required field",
    translationKey: "notInterestedReasonValidation",
};

export const NotInterestedFeedbackMessage = {
    name: "Thank you for your feedback!",
    translationKey: "notInterestedFeedbackMessage",
};

export const NotInterestedSubmitFailed = {
    name: "Something went wrong, please try again later",
    translationKey: "notInterestedSubmitFailed",
};

export const enum NotInterestedReasonEnum {
    NOT_INTERESTED_IN_APPLYING_TO_UNI = "NOT_INTERESTED_IN_APPLYING_TO_UNI",
    NOT_INTERESTED_IN_UPDATES_FROM_UNI = "NOT_INTERESTED_IN_UPDATE",
    NOT_INTERESTED_OTHER = "NOT_INTERESTED_OTHER",
}

export const NotInterestedReasonOptions = [
    {
        name: "Not interested in applying to this institution",
        translationKey: "notInterestedInApplying",
        value: NotInterestedReasonEnum.NOT_INTERESTED_IN_APPLYING_TO_UNI,
    },
    {
        name: "Not interested in updates from this institution",
        translationKey: "notInterestedInUpdates",
        value: NotInterestedReasonEnum.NOT_INTERESTED_IN_UPDATES_FROM_UNI,
    },
    {
        name: "Other",
        translationKey: "notInterestedOther",
        value: NotInterestedReasonEnum.NOT_INTERESTED_OTHER,
    },
];

export const notInterestedStageMutation = gql`
    mutation NotInterestedStageMutation(
        $universityId: ObjectId!
        $decisionStage: DecisionStageEnum!
        $prospectStageLocation: DecisionStageLocationEnum!
        $notInterestedReason: NotInterestedReasonEnum!
    ) {
        saveNotInterestedStage(
            notInterestedStageInput: {
                universityId: $universityId
                decisionStage: $decisionStage
                decisionStageLocation: $prospectStageLocation
                notInterestedReason: $notInterestedReason
            }
        ) {
            userId
        }
    }
`;
